export const LOADING_WEATHER = "LOADING_WEATHER";
